const makeClient = (data) => {
    return {
        ...data,
        user_id: data?.user_id == ""? null : data?.user_id   ,
        limit_available() {
            const value = (this.credit + this.max_negative_credit)
            return (value < 0 ? 0 : value)
        },
    }
}

export default makeClient